/**
 * Who operates the service.
 *
 * Kept in its own module, separate from the legal document text, because the footer
 * needs these few fields on *every* page. When they lived in legal.ts the footer
 * pulled the entire Terms/Privacy/Refund/Cookies prose into the bundle of every
 * route — about 39 kB shipped to readers who never open a legal page.
 *
 * Every field except `tradingName` is optional and currently commented out. The
 * documents are written to read correctly either way: they fall back to the brand
 * name and to the contact form, and omit the company-identification and
 * governing-law clauses entirely rather than printing an empty placeholder.
 * Uncomment a field and the corresponding clause appears.
 */

export interface OperatorDetails {
  /** Public brand name. Always present. */
  tradingName: string;
  /** Registered company or sole-trader name that operates the service. */
  legalName?: string;
  /** Company/tax registration number. */
  registrationNumber?: string;
  /** Registered postal address. */
  address?: string;
  /** Country of establishment — determines the applicable consumer law. */
  country?: string;
  /** Courts competent for disputes. */
  jurisdiction?: string;
  /** Monitored support inbox. */
  supportEmail?: string;
  /** Inbox for data-protection requests (may be the same as supportEmail). */
  privacyEmail?: string;
}

export const OPERATOR: OperatorDetails = {
  tradingName: "SmsEmpire",

  // ───────────────────────────────────────────────────────────────────────────
  // DATOS LEGALES — descomentar y rellenar cuando se quieran publicar.
  //
  // Cada línea que descomentes activa su cláusula en los documentos:
  //   legalName          → identifica al operador en términos y privacidad
  //   registrationNumber → aparece junto a la razón social
  //   address            → aparece junto a la razón social
  //   country            → activa la ley aplicable
  //   jurisdiction       → activa el fuero de los tribunales
  //   supportEmail       → sustituye "el formulario de contacto" por la dirección
  //   privacyEmail       → dirección para ejercer derechos RGPD
  //
  // Mientras estén comentados, los documentos siguen siendo coherentes: hablan de
  // "SmsEmpire" y remiten al formulario de contacto. Lo que no pueden hacer es
  // identificar al responsable, que es un requisito propio del comercio en la UE.
  // ───────────────────────────────────────────────────────────────────────────
  //
  // legalName: "Mi Empresa S.L.",
  // registrationNumber: "B12345678",
  // address: "Calle Ejemplo 1, 28001 Madrid, España",
  // country: "España",
  // jurisdiction: "Madrid, España",
  // supportEmail: "soporte@tudominio.com",
  // privacyEmail: "privacidad@tudominio.com",
};

/** Name to use when referring to the operator in prose. */
export function operatorName(): string {
  return OPERATOR.legalName ?? OPERATOR.tradingName;
}

/** True while the company-identification details are still hidden. */
export function operatorDetailsHidden(): boolean {
  return !OPERATOR.legalName || !OPERATOR.address || !OPERATOR.registrationNumber;
}
